export const TEST_BUILD_TYPE = 'build';
